// Utils
import { formatTimestampByTimezone } from "utils/format";

// Const
import { firmwareAvailabilitiesLabels } from '../const';

export const getMainSendRequestParams = ({
  auth,
}) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const apiPaths = {
    org: `${apiBaseUrl}/firmware/setting.read`,
    site: `${apiBaseUrl}/sites/:siteId/firmware/setting.read`
  };
  const apiKey = apiPaths[auth.scopeLevel];

  const restfulParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
  };

  const restfulParams = isStandaloneMode ? restfulParamsConfig["standalone"] : restfulParamsConfig["nonStandalone"];

  return {
    apiKey,
    restfulParams
  };
}

export const initTableData = ({
  responseData
}) => {
  return responseData.map((data, index) => {
    const { firmwareAvailability, targetFirmwareSchedule, lastUpgradeTime, siteTimezone } = data;
    const targetFirmwareScheduleDate = targetFirmwareSchedule ? formatTimestampByTimezone(targetFirmwareSchedule, siteTimezone) : null;
    const lastUpgradeTimeDate = lastUpgradeTime && siteTimezone ? formatTimestampByTimezone(lastUpgradeTime, siteTimezone) : null;
    const latestFirmware = data?.firmwareList?.[0] ?? null;

    const latestFirmwareVersion = latestFirmware ? latestFirmware.version : null;
    const latestFirmwareVersionHasReleaseNote = latestFirmware ? latestFirmware.hasReleaseNote : false;

    return {
      ...data,
      index,
      firmwareAvailabilitiesLabel: firmwareAvailabilitiesLabels[firmwareAvailability],
      targetFirmwareScheduleDate: targetFirmwareSchedule,
      targetFirmwareScheduleDateLabel: targetFirmwareScheduleDate,
      lastUpgradeTimeDate: lastUpgradeTime,
      lastUpgradeTimeDateLabel: lastUpgradeTimeDate,
      latestFirmwareVersion,
      latestFirmwareVersionHasReleaseNote
    }
  })
}

export const getHwVersionLabel = ({ hwVer }) => {
  let label = "-";

  if (hwVer == null) return label;

  const hw = String(hwVer);
  if (hw.length === 0) return label;
  else if (hw.length === 1) label = hw + 'x';
  else label = hw;

  return label;
}